export default __webpack_public_path__ + "static/media/close-accent.9c778630.svg";